"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffinityListStyled = void 0;
exports.AffinityListStyled = styled.article.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: stretch;

  > h2 {
    display: flex;
    flex-direction: column;
    font-weight: 600;

    > span {
      font-size: 1.5em;

      &.subtitle {
        font-size: 1em;
      }
    }
  }

  >.matrix {
    >.category {
      >.skills {
        >.skill {
          display: flex;
          flex-flow: row nowrap;
          gap: 3em;
          align-items: center;
          justify-content: flex-start;

          >.name {
            flex: 1 1 15em;
            overflow: hidden;
            width: 0;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          >.destroy {
            min-width: 1em;
            cursor: pointer;
          }
        }
      }
    }
  }
}
`;
//# sourceMappingURL=AffinityList.styled.js.map